import { createSelector } from '@ngrx/store';

import { memoizeSelector, createSingleEntityStore, pipeState } from '@recruitee/ngrx';

import { EntityStoreKey, FeatureFlag, FeatureFlagsMap } from '../types';

const { actions, selectors, reducer, namespace } = createSingleEntityStore<FeatureFlagsMap>()(
  EntityStoreKey.featureFlags,
  {
    customActions: adapter => ({
      init: (state, payload: FeatureFlagsMap) =>
        pipeState(
          state,
          next => adapter.save(next, payload),
          next => adapter.markAsLoaded(next),
        ),
    }),
  },
);

const FeatureFlagSelectors = {
  ...selectors,
  featureEnabled: memoizeSelector((feature: FeatureFlag) =>
    createSelector(selectors.data, (featureFlagsMap: FeatureFlagsMap) => featureFlagsMap[feature]),
  ),
};

export {
  actions as FeatureFlagEntityActions,
  reducer as FeatureFlagReducer,
  namespace as FeatureFlagNamespace,
  FeatureFlagSelectors,
};
